module.exports = __webpack_public_path__ + "img/28.8155013c.jpg";